module.exports = __webpack_public_path__ + "img/img-3-8mobile.90cc8b90.webp";